// extracted by mini-css-extract-plugin
module.exports = {"head":"PlpTop_head__rRsdM","title":"PlpTop_title__iN5qv","lead":"PlpTop_lead__3erst","subCategories":"PlpTop_subCategories__U79sp","active":"PlpTop_active__dc2sx"};